import { NotFoundPageStyled } from './style';

export const NotFoundPage = () => (
  <NotFoundPageStyled>Not found</NotFoundPageStyled>
);
